import {
	Backdrop,
	Box,
	Button,
	Card,
	Chip,
	CircularProgress,
	Divider,
	IconButton,
	TextField,
	Typography,
	useMediaQuery,
} from '@mui/material'
import { Fragment, useCallback, useEffect, useRef, useState } from 'react'
import UserLayout from '../../layouts/UserLayout'
import { useLocation, useNavigate } from 'react-router-dom'
import HourglassTopOutlinedIcon from '@mui/icons-material/HourglassTopOutlined'
import AutorenewOutlinedIcon from '@mui/icons-material/AutorenewOutlined'
import axios from 'axios'
import { DOMAIN, api } from '../../utils/api'
import { handleError } from '../../utils/error'
import { confirmImportStockFormByStoreActions, currentUserActions } from '../../redux/store'
import { useDispatch, useSelector } from 'react-redux'
import { getFromStorage } from '../../utils/storage'
import ConfirmImportStockByStoreForm from '../../components/ConfirmImportStockByStoreForm'
import PickDateWithoutShiftGrow from '../../components/PickDateWithoutShiftGrow'
import WbSunnyIcon from '@mui/icons-material/WbSunny'
import DarkModeIcon from '@mui/icons-material/DarkMode'
import AddPhotoAlternateRoundedIcon from '@mui/icons-material/AddPhotoAlternateRounded'
import { mainGreen, mainRed } from '../../utils/color'
import { getTextOfInternalSale } from '../../utils/helper'

export default function StockManagementByStoreMultiPic() {
	const location = useLocation()
	const dispatch = useDispatch()
	const navigate = useNavigate()
	const mediaMd = useMediaQuery('(min-width:768px)')
	const token = getFromStorage('current-user')?.accessToken
	const { currentUser } = useSelector((state) => state.currentUser)
	const [showBackdrop, setShowBackdrop] = useState(false)
	const [showCheckStockBackdrop, setShowCheckStockBackdrop] = useState(false)
	const [showEditCheckStockBackdrop, setShowEditCheckStockBackdrop] = useState(false)
	const [loadingCheckStock, setLoadingCheckStock] = useState(false)
	const [loadingFreshExport, setLoadingFreshExport] = useState(false)
	const [checkFreshStockStatus, setCheckFreshStockStatus] = useState()
	const { showConfirmImportByStoreForm } = useSelector((state) => state.confirmImportStockByStoreForm)
	const [subStock, setSubStock] = useState({
		freshInventory: '',
		cookedInventory: '',
	})
	const [isViewerOpen, setIsViewerOpen] = useState(false)
	const [currentImage, setCurrentImage] = useState(null)
	const [disabled, setDisabled] = useState(false)
	const [fileUpload, setFileUpload] = useState([])
	const [preview, setPreview] = useState([])

	const openImageViewer = (photo) => {
		setCurrentImage(photo)
		setIsViewerOpen(true)
	}

	const closeImageViewer = () => {
		setCurrentImage(null)
		setIsViewerOpen(false)
	}
	const [requests, setRequests] = useState([])

	const [history, setHistory] = useState([])
	const [checkStock, setCheckStock] = useState('')
	const [editCheckStock, setEditCheckStock] = useState('')
	const [shift, setShift] = useState({ morning: true, afternoon: false })
	const today = new Date()
	const [timePick, setTimePick] = useState({
		date: today.getDate()?.toString(),
		month: (today.getMonth() + 1)?.toString(),
		year: today.getFullYear()?.toString(),
	})

	const setTime = (time) => {
		setTimePick(time)
	}

	useEffect(() => {
		if (!fileUpload) {
			setPreview(undefined)
			return
		}
		let preview = []
		for (let i = 0; i < fileUpload.length; i++) {
			preview.push(URL.createObjectURL(fileUpload[i]))
		}
		setPreview(preview)
	}, [fileUpload])

	const onFileChange = async (e) => {
		setFileUpload(e.target.files)
	}

	const checkStockSubmit = async function (e) {
		e.preventDefault()
		if (checkStock.trim() === '') {
			alert('Khối lượng không được để trống!')
			return
		}
		if (+checkStock < 0) {
			alert('Tồn kho không bé hơn 0!')
		}

		setLoadingCheckStock(true)
		setDisabled(true)
		try {
			const formData = new FormData()
			formData.append('quantity', checkStock)
			for (let i = 0; i < fileUpload.length; i++) {
				formData.append('image', fileUpload[i])
			}
			await axios({
				method: 'POST',
				url: `${DOMAIN}/sub-stock/check-fresh/${currentUser.store}`,
				data: formData,

				headers: {
					Authorization: `Bearer ${token}`,
					'Content-Type': 'multipart/form-data',
				},
			})
			setFileUpload([])
			setShowCheckStockBackdrop(false)
			setLoadingCheckStock(false)
			setDisabled(false)
			getCheckFreshStockStatus()
		} catch (err) {
			handleError(err)
			dispatch(currentUserActions.isLogout())
			navigate('/login')
		}
	}

	const editCheckStockSubmit = async function (e, id) {
		e.preventDefault()
		if (editCheckStock.trim() === '') {
			alert('Khối lượng không được để trống!')
			return
		}
		if (+editCheckStock < 0) {
			alert('Tồn kho không bé hơn 0!')
		}
		setDisabled(true)
		try {
			await axios({
				method: 'PUT',
				url: `${DOMAIN}/sub-stock/edit-check-fresh`,
				data: { editCheckStock, id },

				headers: {
					Authorization: `Bearer ${token}`,
				},
			})
			setShowEditCheckStockBackdrop(false)
			setDisabled(false)
			setEditCheckStock('')
			getCheckFreshStockStatus()
		} catch (err) {
			handleError(err)
			dispatch(currentUserActions.isLogout())
			navigate('/login')
		}
	}

	const getCheckFreshStockStatus = useCallback(
		async function () {
			try {
				const response = await axios({
					url: `${DOMAIN}/sub-stock/check-fresh-stock/${currentUser.store}`,
					headers: {
						Authorization: `Bearer ${token}`,
					},
					method: 'GET',
				})
				setCheckFreshStockStatus(response.data)
			} catch (error) {
				console.log(error.response.data.message)
			}
		},
		[token, currentUser.store],
	)

	useEffect(() => {
		getCheckFreshStockStatus()
	}, [getCheckFreshStockStatus])

	const cancelCheckFreshStock = async () => {
		try {
			await axios({
				url: `${DOMAIN}/sub-stock/cancel-check-fresh-stock/${currentUser.store}`,
				method: 'PUT',
				headers: {
					Authorization: `Bearer ${token}`,
				},
			})
			await getCheckFreshStockStatus()
		} catch (err) {
			handleError(err)
			dispatch(currentUserActions.isLogout())
			navigate('/login')
		}
	}

	const getHistory = useCallback(
		async function () {
			const { date, month, year } = timePick
			try {
				const response = await axios({
					url: `${DOMAIN}/sub-stock/fresh-history/${currentUser.store}?shift=${shift.morning}&date=${date}&month=${month}&year=${year}`,
					headers: {
						Authorization: `Bearer ${token}`,
					},
					method: 'GET',
				})
				setHistory(response.data)
			} catch (error) {
				console.log(error.response.data.message)
			}
		},
		[token, timePick, shift.morning, currentUser.store],
	)

	useEffect(() => {
		getHistory()
	}, [getHistory])

	const getSubStock = useCallback(
		async function () {
			try {
				const response = await axios({
					url: `${DOMAIN}/sub-stock/${currentUser.store}`,
					method: 'GET',
					headers: {
						Authorization: `Bearer ${token}`,
					},
				})
				setSubStock(response.data[0])
			} catch (err) {
				handleError(err)
				dispatch(currentUserActions.isLogout())
				navigate('/login')
			}
		},
		[dispatch, navigate, token, currentUser.store],
	)

	useEffect(() => {
		getSubStock()
	}, [getSubStock])

	const getRequests = useCallback(
		async function () {
			let url
			if (currentUser.permission.includes('manageStockByStore')) {
				url = `${DOMAIN}/requests/${currentUser.store}`
			}
			if (currentUser.permission.includes('confirmImportStockByStore')) {
				url = `${DOMAIN}/confirm-requests/${currentUser.store}`
			}
			try {
				const response = await axios({
					url,
					method: 'GET',
					headers: {
						Authorization: `Bearer ${token}`,
					},
				})
				setRequests(response.data)
			} catch (err) {
				console.log(err.response.data.message)
			}
		},
		[token, currentUser.store, currentUser.permission],
	)

	useEffect(() => {
		getRequests()
	}, [getRequests])

	const deleteRequestFromStore = async (id) => {
		try {
			const response = await axios({
				url: api.DELETE_REQUEST_FROM_STORE,
				method: 'DELETE',
				headers: {
					Authorization: `Bearer ${token}`,
				},
				data: { id },
			})
			if (response.data.message) {
				alert(response.data.message)
			}
			await getRequests()
		} catch (err) {
			handleError(err)
			dispatch(currentUserActions.isLogout())
			navigate('/login')
		}
	}

	const handleChangeCheckStock = (e) => {
		setCheckStock(e.target.value)
	}

	const handleChangeEditCheckStock = (e) => {
		setEditCheckStock(e.target.value)
	}

	const handleSubmit = async () => {
		try {
			const response = await axios({
				url: `${DOMAIN}/request-stock/${currentUser.store}`,
				method: 'POST',
				headers: {
					Authorization: `Bearer ${token}`,
				},
			})
			if (response.data.message) {
				alert(response.data.message)
			}
			await getRequests()
		} catch (err) {
			handleError(err)
			dispatch(currentUserActions.isLogout())
			navigate('/login')
		}
	}

	const refresh = function () {
		getSubStock()
		getRequests()
		getHistory()
		getCheckFreshStockStatus()
	}

	const freshExportQuantityRef = useRef()

	const freshExport = async (e, action) => {
		e.preventDefault()
		let data = freshExportQuantityRef.current.value

		if (data.trim() === '') {
			alert('Không thể gửi dữ liệu trống!')
			return
		}

		if (+data < 0) {
			alert('Khối lượng phải lớn hơn 0!')
			return
		}
		freshExportQuantityRef.current.value = ''
		setLoadingFreshExport(true)
		setDisabled(true)
		try {
			const formData = new FormData()
			formData.append('data', data)
			for (let i = 0; i < fileUpload.length; i++) {
				formData.append('image', fileUpload[i])
			}

			const response = await axios({
				url: `${DOMAIN}/sub-stock/${action}/${currentUser.store}`,
				method: 'PUT',
				headers: {
					Authorization: `Bearer ${token}`,
					'Content-Type': 'multipart/form-data',
				},
				data: formData,
			})
			if (response.data.message) {
				alert(response.data.message)
			}
			await getSubStock()
			await getHistory()
			setShowBackdrop(false)
			setLoadingFreshExport(false)
			setDisabled(false)
		} catch (err) {
			handleError(err)
			dispatch(currentUserActions.isLogout())
			navigate('/login')
		}
	}

	return (
		<UserLayout>
			<Box
				sx={{
					maxWidth: 992,
					margin: '0 auto',
				}}>
				<Backdrop
					sx={{
						color: '#fff',
						zIndex: 999,
						left: mediaMd ? 300 : 0,
					}}
					open={isViewerOpen}
					onClick={closeImageViewer}>
					<img
						loading='lazy'
						src={currentImage}
						alt='attach'
						style={{
							maxHeight: '70%',
							maxWidth: '90%',
						}}
						onClick={(e) => {
							e.stopPropagation()
						}}
					/>
				</Backdrop>
				<Box sx={{ display: 'flex' }}>
					<h3
						style={{
							margin: 0,
							padding: '10px',
							textAlign: 'center',
							background: location.pathname === '/store-manager/stock/fresh' ? mainGreen : 'rgba(0, 0, 0, 0.08)',
							color: location.pathname === '/store-manager/stock/fresh' ? '#fff' : '#000',
							cursor: 'pointer',
							width: '50%',
						}}
						onClick={() => {
							navigate('/store-manager/stock/fresh')
						}}>
						KHO SỐNG
					</h3>
					<h3
						style={{
							margin: 0,
							padding: '10px',
							textAlign: 'center',
							background: location.pathname === '/store-manager/stock/product' ? mainGreen : 'rgba(0, 0, 0, 0.08)',
							color: location.pathname === '/store-manager/stock/product' ? '#fff' : '#000',
							cursor: 'pointer',
							width: '50%',
						}}
						onClick={() => {
							navigate('/store-manager/stock/product')
						}}>
						KHO CHÍN
					</h3>
				</Box>
				<Card
					sx={{
						mb: 2,
						padding: '10px',
					}}>
					<Box display='flex' justifyContent='space-between'>
						<Button
							sx={{
								textTransform: 'none',
								padding: '3px',
								color: mainGreen,
								borderColor: mainGreen,
								'&:hover': {
									borderColor: mainGreen,
								},
							}}
							variant='outlined'
							size='small'
							onClick={refresh}>
							<AutorenewOutlinedIcon sx={{ fontSize: '16px' }} />
							Cập nhật
						</Button>
						<Button
							sx={{
								textTransform: 'none',
								background: mainGreen,
								'&:hover': { background: mainGreen },
							}}
							variant='contained'
							size='small'
							onClick={() => {
								navigate('/store-manager/stock/params')
							}}>
							Thông số
						</Button>
					</Box>
					<Box
						sx={{
							mt: 2,
							display: 'flex',
							justifyContent: 'space-between',
							alignItems: 'center',
						}}>
						<h3 style={{ margin: 0, textAlign: 'center' }}>TỒN SỐNG</h3>
						<Box
							sx={{
								background: '#637381',
								padding: '5px 10px',
								borderRadius: '5px',
							}}>
							<Typography
								sx={{
									color: '#fff',
								}}>
								<b>
									{String(subStock?.freshInventory) !== ''
										? Number(subStock?.freshInventory)?.toFixed(1)
										: subStock?.freshInventory}{' '}
									kg
								</b>
							</Typography>
						</Box>
					</Box>
					<Divider sx={{ mt: 2, mb: 2 }} />
					<Button
						size='small'
						variant='outlined'
						sx={{
							mr: 1,
							mb: 1,
							color: mainGreen,
							borderColor: mainGreen,
							'&:hover': {
								borderColor: mainGreen,
							},
						}}
						onClick={() => {
							setShowBackdrop(true)
						}}>
						Xuất nướng
					</Button>
					<Backdrop
						sx={{
							color: '#fff',
							zIndex: (theme) => theme.zIndex.drawer + 1,
							left: mediaMd ? 300 : 0,
						}}
						open={showBackdrop}>
						<Card
							sx={{ padding: '10px 20px', width: '280px' }}
							onClick={(e) => {
								e.stopPropagation()
							}}>
							<Typography
								sx={{
									textAlign: 'center',
									fontSize: '18px',
									fontWeight: 'bold',
									mb: 1,
								}}>
								Xuất nướng
							</Typography>
							{loadingFreshExport && (
								<Box sx={{ textAlign: 'center', mt: 2 }}>
									<CircularProgress sx={{ color: mainGreen }} />
								</Box>
							)}
							{!loadingFreshExport && (
								<>
									<TextField fullWidth type='number' label='Khối lượng (kg)' inputRef={freshExportQuantityRef} />
									<Box sx={{ mt: 2 }}>
										{preview?.map((img, index) => {
											return (
												<img
													loading='lazy'
													key={index}
													style={{
														width: 50,
														marginRight: '8px',
													}}
													src={img}
													alt='preview'
												/>
											)
										})}
										<Box>
											<IconButton sx={{ padding: '0' }}>
												<label htmlFor='choose-photo-export-fresh' style={{ display: 'flex', cursor: 'pointer' }}>
													<AddPhotoAlternateRoundedIcon sx={{ color: mainGreen }} />
												</label>
											</IconButton>
											<input
												multiple
												accept='image/*'
												onChange={onFileChange}
												id='choose-photo-export-fresh'
												type='file'
												style={{ display: 'none' }}
											/>
										</Box>
									</Box>
									<Box display='flex' justifyContent='space-between'>
										<Button
											disabled={disabled}
											sx={{
												mt: 2,
												width: '75%',
												mr: 1,
												background: mainGreen,
												'&:hover': { background: mainGreen },
											}}
											size='small'
											variant='contained'
											onClick={(e) => {
												freshExport(e, 'fresh-export')
											}}>
											Xác nhận
										</Button>
										<Button
											sx={{
												mt: 2,
												background: mainRed,
												'&:hover': { background: mainRed },
											}}
											variant='contained'
											size='small'
											onClick={() => {
												setShowBackdrop(false)
												setFileUpload([])
												freshExportQuantityRef.current.value = ''
											}}>
											Hủy
										</Button>
									</Box>
								</>
							)}
						</Card>
					</Backdrop>
					<Button
						size='small'
						variant='outlined'
						sx={{
							mb: 1,
							color: mainRed,
							borderColor: mainRed,
							'&:hover': {
								borderColor: mainRed,
							},
						}}
						onClick={() => {
							setShowCheckStockBackdrop(true)
						}}>
						Kiểm kho sống
					</Button>
					<Divider sx={{ mt: 1, mb: 1 }} />
					<Typography>
						<b>Kiểm kho:</b>{' '}
						<span>
							{checkFreshStockStatus ? <span style={{ color: mainRed }}>đang chờ duyệt</span> : 'chưa có dữ liệu'}
						</span>
					</Typography>
					{checkFreshStockStatus && (
						<>
							<b>{checkFreshStockStatus?.user.name}</b> đang kiểm kho sống. Tồn thực tế{' '}
							<b>{checkFreshStockStatus?.quantity?.toFixed(1)}</b> kg. Tồn hệ thống{' '}
							<b>{checkFreshStockStatus?.checkStockSystem?.toFixed(1)}</b> kg. Chênh lệch:{' '}
							{checkFreshStockStatus?.quantity - checkFreshStockStatus?.checkStockSystem > 0 ? (
								<b>+{(checkFreshStockStatus?.quantity - checkFreshStockStatus?.checkStockSystem).toFixed(1)} </b>
							) : (
								<b>{(checkFreshStockStatus?.quantity - checkFreshStockStatus?.checkStockSystem).toFixed(1)} </b>
							)}
							kg
							<Box sx={{ mt: 2 }}>
								<Button
									size='small'
									variant='outlined'
									sx={{
										mr: 1,
										mb: 1,
										color: mainGreen,
										borderColor: mainGreen,
										'&:hover': {
											borderColor: mainGreen,
										},
									}}
									onClick={() => {
										setShowEditCheckStockBackdrop(true)
									}}>
									Chỉnh sửa
								</Button>
								<Button
									size='small'
									variant='outlined'
									sx={{
										mr: 1,
										mb: 1,
										color: mainRed,
										borderColor: mainRed,
										'&:hover': {
											borderColor: mainRed,
										},
									}}
									onClick={() => {
										cancelCheckFreshStock()
									}}>
									Hủy kiểm kho
								</Button>
							</Box>
						</>
					)}
					<Backdrop
						sx={{
							color: '#fff',
							zIndex: (theme) => theme.zIndex.drawer + 1,
							left: mediaMd ? 300 : 0,
						}}
						open={showEditCheckStockBackdrop}>
						<Card
							sx={{ padding: '10px 20px', width: '280px' }}
							onClick={(e) => {
								e.stopPropagation()
							}}>
							<Typography
								sx={{
									textAlign: 'center',
									fontSize: '18px',
									fontWeight: 'bold',
									mb: 1,
								}}>
								Tồn kho sống thực tế
							</Typography>
							<TextField
								fullWidth
								type='number'
								label='kg'
								value={editCheckStock}
								onChange={handleChangeEditCheckStock}
							/>
							<Box display='flex' justifyContent='space-between'>
								<Button
									disabled={disabled}
									sx={{
										mt: 2,
										width: '75%',
										mr: 1,
										background: mainGreen,
										'&:hover': { background: mainGreen },
									}}
									size='small'
									variant='contained'
									onClick={(e) => {
										editCheckStockSubmit(e, checkFreshStockStatus._id)
									}}>
									Xác nhận
								</Button>
								<Button
									sx={{
										mt: 2,
										background: mainRed,
										'&:hover': { background: mainRed },
									}}
									variant='contained'
									size='small'
									onClick={() => {
										setShowEditCheckStockBackdrop(false)
										setEditCheckStock('')
									}}>
									Hủy
								</Button>
							</Box>
						</Card>
					</Backdrop>
					<Backdrop
						sx={{
							color: '#fff',
							zIndex: (theme) => theme.zIndex.drawer + 1,
							left: mediaMd ? 300 : 0,
						}}
						open={showCheckStockBackdrop}>
						<Card
							sx={{ padding: '10px 20px', width: '280px' }}
							onClick={(e) => {
								e.stopPropagation()
							}}>
							<Typography
								sx={{
									textAlign: 'center',
									fontSize: '18px',
									fontWeight: 'bold',
									mb: 1,
								}}>
								Tồn kho sống
							</Typography>
							{loadingCheckStock && (
								<Box sx={{ textAlign: 'center', mt: 2 }}>
									<CircularProgress sx={{ color: mainGreen }} />
								</Box>
							)}

							{!loadingCheckStock && (
								<>
									<TextField
										fullWidth
										type='number'
										label='KL thực tế (kg)'
										value={checkStock}
										onChange={handleChangeCheckStock}
									/>
									<Box sx={{ mt: 2 }}>
										{preview?.map((img, index) => {
											return (
												<img
													loading='lazy'
													key={index}
													style={{
														width: 50,
														marginRight: '8px',
													}}
													src={img}
													alt='preview'
												/>
											)
										})}
										<Box>
											<IconButton sx={{ padding: '0' }}>
												<label htmlFor='choose-photo-check-fresh' style={{ display: 'flex', cursor: 'pointer' }}>
													<AddPhotoAlternateRoundedIcon sx={{ color: mainGreen }} />
												</label>
											</IconButton>
											<input
												multiple
												accept='image/*'
												onChange={onFileChange}
												id='choose-photo-check-fresh'
												type='file'
												style={{ display: 'none' }}
											/>
										</Box>
									</Box>
									<Box display='flex' justifyContent='space-between'>
										<Button
											disabled={disabled}
											sx={{
												mt: 2,
												width: '75%',
												mr: 1,
												background: mainGreen,
												'&:hover': { background: mainGreen },
											}}
											size='small'
											variant='contained'
											onClick={(e) => {
												checkStockSubmit(e)
											}}>
											Xác nhận
										</Button>
										<Button
											sx={{
												mt: 2,
												background: mainRed,
												'&:hover': { background: mainRed },
											}}
											variant='contained'
											size='small'
											onClick={() => {
												setShowCheckStockBackdrop(false)
												setFileUpload([])
												setCheckStock('')
											}}>
											Hủy
										</Button>
									</Box>
								</>
							)}
						</Card>
					</Backdrop>
				</Card>

				<Card sx={{ padding: '10px', mb: 2 }}>
					<Box display='flex' justifyContent='space-between'>
						<Typography
							sx={{
								textDecoration: 'underline',
								fontStyle: 'italic',
								color: '#1939B7',
								cursor: 'pointer',
							}}
							onClick={() => {
								navigate('/store-manager/stock/history')
							}}>
							Lịch sử nhập kho
						</Typography>
						<Button
							sx={{
								textTransform: 'none',
								background: mainGreen,
								'&:hover': { background: mainGreen },
							}}
							size='small'
							variant='contained'
							onClick={() => {
								handleSubmit()
							}}>
							Gửi yêu cầu nhập
						</Button>
					</Box>
					<Typography
						sx={{
							textAlign: 'center',
							fontSize: '18px',
							fontWeight: 'bold',
							mb: 1,
							mt: 1,
						}}>
						Yêu cầu nhập hàng
					</Typography>
					{requests.length === 0 && (
						<Typography sx={{ textAlign: 'center', fontStyle: 'italic' }}>(Chưa có dữ liệu)</Typography>
					)}
					{requests.length > 0 &&
						requests?.map((req, index) => {
							return (
								<Fragment key={index}>
									<Box display='flex' justifyContent='space-between' alignItems='flex-end'>
										<Box>
											{req.request.status === 'approved' && (
												<p
													style={{
														display: 'inline-flex',
														fontSize: '12px',
														color: '#fff',
														background: mainGreen,
														padding: '1px 5px',
														borderRadius: '5px',
														marginBottom: '2px',
														alignItems: 'flex-start',
													}}>
													<HourglassTopOutlinedIcon sx={{ fontSize: '16px', marginRight: '2px' }} />
													Chờ nhận hàng
												</p>
											)}
											{req.request.status === 'confirm' && (
												<p
													style={{
														display: 'inline-flex',
														fontSize: '12px',
														color: '#fff',
														background: mainGreen,
														padding: '1px 5px',
														borderRadius: '5px',
														marginBottom: '2px',
														alignItems: 'flex-start',
													}}>
													<HourglassTopOutlinedIcon sx={{ fontSize: '16px', marginRight: '5px' }} />
													Chờ cửa hàng xác nhận
												</p>
											)}
											<Typography
												sx={{
													display: 'flex',
													alignItems: 'center',
													mt: req.request.status === 'pending' ? 1 : 0,
												}}>
												<span style={{ marginRight: '5px', fontWeight: 'bold' }}>{req.request.store?.name}</span>{' '}
												{req.quantity && <b>: {req.quantity}kg</b>}
											</Typography>
											<Typography
												sx={{
													fontSize: '12px',
													color: mainGreen,
													fontWeight: 'bold',
												}}>
												{req.request.user?.name} tạo đề xuất - {req.request.timeStamp}
											</Typography>
											<Typography sx={{ fontStyle: 'italic', fontSize: '14px' }}>
												{req.note && <span>{req.note}</span>}
											</Typography>
											{req?.deliveryReceiptPicture?.map((image, index) => {
												return (
													<img
														loading='lazy'
														key={index}
														src={image}
														onClick={(e) => {
															openImageViewer(image)
														}}
														width='30'
														height='30'
														style={{
															marginRight: '8px',
															marginTop: '2px',
															cursor: 'pointer',
														}}
														alt=''
													/>
												)
											})}
										</Box>
										{req.request.status === 'confirm' && (
											<Box>
												<Button
													size='small'
													variant='contained'
													sx={{
														textTransform: 'none',
														mr: 1,
														minWidth: 0,
														padding: '0 5px',
														background: mainGreen,
														'&:hover': { background: mainGreen },
													}}
													onClick={() => {
														dispatch(confirmImportStockFormByStoreActions.request(req))
														dispatch(confirmImportStockFormByStoreActions.showConfirmImportStockByStoreForm())
													}}>
													Xác nhận
												</Button>
											</Box>
										)}
										{req.request.status === 'pending' && (
											<Box>
												<Button
													size='small'
													variant='contained'
													sx={{
														textTransform: 'none',
														padding: '0 5px',
														minWidth: 0,
														background: mainRed,
														'&:hover': { background: mainRed },
													}}
													onClick={() => {
														deleteRequestFromStore(req._id)
													}}>
													Hủy yêu cầu
												</Button>
											</Box>
										)}
									</Box>
									<Divider sx={{ mt: 1 }} />
								</Fragment>
							)
						})}
				</Card>
				<Card sx={{ padding: '10px', mb: 2 }}>
					<Typography
						sx={{
							textAlign: 'center',
							fontSize: '18px',
							fontWeight: 'bold',
							mb: 1,
						}}>
						Lịch sử xuất và tái nhập
					</Typography>
					<PickDateWithoutShiftGrow time={timePick} setTime={setTime} />
					<Box display='flex' justifyContent='center'>
						<Chip
							onClick={() => {
								if (shift.morning === false) {
									setShift({ morning: true, afternoon: false })
								}
							}}
							size='small'
							sx={{
								cursor: 'pointer',
								mr: 4,
								background: shift.morning ? mainGreen : undefined,
								color: shift.morning ? '#fff' : '#000',
								'&:hover': {
									background: shift.morning ? mainGreen : undefined,
									color: shift.morning ? '#fff' : '#000',
								},
							}}
							label={
								<Typography
									sx={{
										fontSize: '14px',
										display: 'flex',
										justifyContent: 'center',
										alignItems: 'center',
										lineHeight: 1.3,
									}}>
									{' '}
									<WbSunnyIcon sx={{ mr: 1, fontSize: '20px' }} /> Sáng
								</Typography>
							}
						/>
						<Chip
							onClick={() => {
								if (shift.afternoon === false) {
									setShift({ morning: false, afternoon: true })
								}
							}}
							size='small'
							sx={{
								cursor: 'pointer',
								background: shift.afternoon ? mainGreen : undefined,
								color: shift.afternoon ? '#fff' : '#000',
								'&:hover': {
									background: shift.afternoon ? mainGreen : undefined,
									color: shift.afternoon ? '#fff' : '#000',
								},
							}}
							label={
								<Typography
									sx={{
										fontSize: '14px',
										display: 'flex',
										justifyContent: 'center',
										alignItems: 'center',
										lineHeight: 1.3,
									}}>
									{' '}
									<DarkModeIcon sx={{ mr: 1, fontSize: '20px' }} /> Chiều
								</Typography>
							}
						/>
					</Box>
					{history?.filter(
						(item) =>
							item.action !== 'checkFreshStock' &&
							!(item.action === 'confirmCheckFreshStock' && !item.checkStockRecord),
					).length === 0 && (
						<Typography sx={{ textAlign: 'center', fontStyle: 'italic', mt: 2 }}>(Chưa có dữ liệu)</Typography>
					)}
					<Box sx={{ mt: 2 }}>
						{history
							?.filter(
								(item) =>
									item.action !== 'checkFreshStock' &&
									!(item.action === 'confirmCheckFreshStock' && !item.checkStockRecord),
							)
							.map((item, index) => {
								return (
									<Fragment key={index}>
										<Typography sx={{ textAlign: 'left', mt: 1 }}>
											<b>{item.user?.name}</b>{' '}
											{item?.action === 'confirmCheckFreshStock' && item?.checkStockRecord && (
												<>
													<span style={{ color: mainGreen }}>
														kiểm kho, tồn thực tế <b>{item?.quantity?.toFixed(1)}kg</b>
													</span>
													. Hệ thống{' '}
													<span style={{ color: mainGreen }}>
														<b>
															{item?.checkStockSystem?.toFixed(1)}
															kg.
														</b>{' '}
													</span>
													Chênh lệch:{' '}
													{item?.quantity - item?.checkStockSystem > 0 ? (
														<b>+{(item?.quantity - item?.checkStockSystem)?.toFixed(1)}</b>
													) : (
														<b>{(item?.quantity - item?.checkStockSystem)?.toFixed(1)}</b>
													)}
													kg. <b>{item?.confirmCheckStock?.user.name}</b> đã duyệt.
												</>
											)}
											{item?.action === 'importFromMainStock' && (
												<span>
													nhập <b>{item?.quantity?.toFixed(1)}kg</b> từ kho tổng.
												</span>
											)}
											{item?.action === 'freshExport' && (
												<span style={{ color: mainRed }}>
													xuất <b>{item?.quantity?.toFixed(1)}kg.</b>
												</span>
											)}{' '}
											{item?.action === 'reImportFresh' && (
												<span style={{ color: mainGreen }}>
													tái nhập <b>{item?.quantity?.toFixed(1)}kg.</b>
												</span>
											)}{' '}
											{item?.action === 'crossStoreSell' || item?.action === 'crossStoreBuy'
												? getTextOfInternalSale(item, 'kg')
												: null}
											{(item?.freshBalance || item?.freshBalance === 0) && (
												<>
													Tồn{' '}
													<b>
														{item?.freshBalance?.toFixed(1)}
														kg
													</b>
												</>
											)}
											{item?.reImportFreshReason && (
												<span
													style={{
														display: 'block',
														fontStyle: 'italic',
														margin: 0,
													}}>
													Lý do: {item?.reImportFreshReason}
												</span>
											)}
										</Typography>
										<Box display='flex' justifyContent='flex-end' alignItems='flex-end' sx={{ mb: 1 }}>
											{item?.importFreshPhoto?.map((img, index) => {
												return (
													<img
														loading='lazy'
														key={index}
														src={img}
														onClick={(e) => {
															openImageViewer(img)
														}}
														width='30'
														height='30'
														style={{
															marginRight: '8px',
															marginTop: '2px',
															cursor: 'pointer',
														}}
														alt=''
													/>
												)
											})}
											{item?.checkStockPicture && (
												<img
													loading='lazy'
													src={item?.checkStockPicture}
													onClick={() => {
														openImageViewer(item?.checkStockPicture)
													}}
													width='30'
													height='30'
													style={{
														marginRight: '8px',
														marginTop: '2px',
														cursor: 'pointer',
													}}
													alt=''
												/>
											)}
											{item?.checkStockMultiPicture?.map((img, index) => {
												return (
													<img
														loading='lazy'
														key={index}
														src={img}
														onClick={(e) => {
															openImageViewer(img)
														}}
														width='30'
														height='30'
														style={{
															marginRight: '8px',
															marginTop: '2px',
															cursor: 'pointer',
														}}
														alt=''
													/>
												)
											})}
											{item?.freshExportPhoto?.map((img, index) => {
												return (
													<img
														loading='lazy'
														key={index}
														src={img}
														onClick={(e) => {
															openImageViewer(img)
														}}
														width='30'
														height='30'
														style={{
															marginRight: '8px',
															marginTop: '2px',
															cursor: 'pointer',
														}}
														alt=''
													/>
												)
											})}
											{item?.reImportFreshPhoto?.map((img, index) => {
												return (
													<img
														loading='lazy'
														key={index}
														src={img}
														onClick={(e) => {
															openImageViewer(img)
														}}
														width='30'
														height='30'
														style={{
															marginRight: '8px',
															marginTop: '2px',
															cursor: 'pointer',
														}}
														alt=''
													/>
												)
											})}
											<Typography
												style={{
													fontStyle: 'italic',
													fontSize: '12px',
													textAlign: 'right',
												}}>
												- {item?.timeStamp} -{' '}
												{item?.confirmCheckStock && (
													<span style={{ color: mainRed }}>Duyệt: {item?.confirmCheckStock.timeStamp}</span>
												)}
											</Typography>{' '}
										</Box>

										<Divider />
									</Fragment>
								)
							})}
					</Box>
				</Card>
			</Box>
			{showConfirmImportByStoreForm && currentUser.permission?.includes('manageStockByStore') && (
				<ConfirmImportStockByStoreForm getRequests={getRequests} getSubStock={getSubStock} />
			)}
		</UserLayout>
	)
}
